export interface PhotoDetails {
  takenDate?: string;
  width?: number;
  height?: number;
  latitude?: number;
  longitude?: number;
  cameraMake?: string;
  cameraModel?: string;
  fNumber?: number;
  focalLength?: number;
  iso?: number;
  exposureTime?: number;
}

class MetadataService {
  private metadata: Map<string, PhotoDetails> = new Map();

  setMetadata(albumId: string, photoIndex: number, metadata: PhotoDetails): void {
    this.metadata.set(`${albumId}-${photoIndex}`, metadata);
  }

  getMetadata(albumId: string, photoIndex: number): PhotoDetails | null {
    return this.metadata.get(`${albumId}-${photoIndex}`) || null;
  }

  clearAlbum(albumId: string): void {
    const keysToDelete = Array.from(this.metadata.keys()).filter(key => key.startsWith(`${albumId}-`));
    keysToDelete.forEach(key => this.metadata.delete(key));
  }
}

export const metadataService = new MetadataService();